/**
 * External Dependencies
 */
import 'jquery';
//import 'bootstrap';

// import modernizr build
require('./vendor/modernizr.js');

// slick carousel
const slick = require('slick-carousel');

// set up js-animation
require('./components/js-anim.js');

// scrolloverflow (for fullpage js scrolling)
require('./vendor/scrolloverflow.min.js');

// full page js
require('./vendor/fullpage.js');
require('./vendor/fullpage.extensions.min.js');

jQuery(function ($) {
  require('./partials/header.js');
  require('./partials/testimonials.js');
  require('./partials/fullpage.js');
  require('./partials/banner.js');
  require('./partials/services.js');
  require('./partials/team-members.js');
  require('./partials/maps.js');

  // rellax library
  require('./components/rellax.js');
});
